import React from 'react';

import s from './StickyWrapper.scss';

interface IProps {
  lead: React.ReactElement; // usually in a sidebar in desktop; header & second-level nav
  children: React.ReactNode;
  className?: string;
  contentClassName?: string;
}

export const StickyWrapper = ({ lead, children, className, contentClassName }: IProps) => {

  return (
    <div className={s('stickyWrapper', className)}>
      <div className={s.stickyWrapper__container}>
        <div className={s.stickyWrapper__row}>
          <div className={s.stickyWrapper__lead}>
            {lead}
          </div>
          <div className={s.stickyWrapper__contentWrap}>
            <div className={s('stickyWrapper__content', contentClassName)}>{children}</div>
          </div>
        </div>
      </div>
    </div>
  );
};
